import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import throttle from 'lodash/throttle';
import { useUserAction } from '../../../helpers/custom-hooks';
import MobileBottomSticky from '../../molecules/mobile-bottom-sticky';
import DfpAd from '../dfp-ad';
import { isDesktop } from 'react-device-detect';
import isEmpty from 'lodash/isEmpty';

const ValidateAccess = ({
  pageType,
  isSubscriber,
  promo_replace_key,
  promo_key,
  activate_all_wap_ads,
  activate_wap1,
  activate_wap2,
  activate_wap3,
  activate_wap4,
  activate_wap5,
  activate_popup,
  activate_gutterAds,
  ads_activation_timings,
}) => {
  const [dynamicAdUnitName, setDynamicAdUnitName] = useState('');
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  );
  const [showAd, setShowAd] = useState(false);
  const [isAdPage, setIsAdPage] = useState(false);
  const hasUserAction = useUserAction();
  let prevScrollpos = null;

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const adPage =
      window.location.pathname === '/ad/detail' ||
      window.location.pathname === '/ad/misc' ||
      window.location.pathname.includes('/lite');
    setIsAdPage(adPage);

    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    const pathname = window.location.pathname.substring(1).split('/')[0];
    const renderAd = pathname !== 'bq-brand-studio' && pageType !== 'video-page-test';
    setShowAd(renderAd);

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (!hasUserAction && !isAdPage) return;
    if (!showAd) return;

    if (typeof window === 'undefined') return;
    const deviceType = isMobile ? 'WAP' : 'Desktop';
    const queryParams = new URLSearchParams(window.location.search);
    const category = window.location.pathname.substring(1).split('/')[0];
    const isPromo =
      category === 'ad' ||
      queryParams.get('utm_source') === 'Yieldmonk' ||
      queryParams.get('utm_campaign') === 'veve';

    let utmCampaign = queryParams.get('utm_campaign');
    if (utmCampaign) utmCampaign = utmCampaign.toLowerCase();

    if (utmCampaign && promo_key.length && promo_replace_key.length) {
      const index = promo_key.indexOf(utmCampaign);
      if (index !== -1 && promo_replace_key[index]) {
        utmCampaign = promo_replace_key[index];
      }
    }

    const isDetailPage = ['story-page', 'story-page-test', 'video-page-test'].includes(pageType);
    const isPromotionalAdStoryPage = window.location.pathname === '/ad/detail';
    const isHomePage =
      window.location.pathname === '/' || window.location.pathname === '/lite/home-test' || isPromo;

    const formattedPageType = isHomePage
      ? 'Home'
      : isPromotionalAdStoryPage || (isPromo && pageType === 'story-page')
        ? 'detail'
        : isDetailPage
          ? 'Detail'
          : 'Listing';

    let formattedCategory = '';
    if (isPromo) {
      formattedCategory = utmCampaign === 'news1' ? 'aff' : utmCampaign;
    } else if (window.location.pathname === '/') {
      formattedCategory = 'homepage';
    } else {
      formattedCategory = category.replace(/[-\s]/g, '');
    }

    const baseAdUnitPath = window.location.href.includes('/lite')
      ? `1068322/Test/Profit_Eng/${deviceType}/${formattedPageType}`
      : `/1068322/Profit_Eng/${deviceType}/${formattedPageType}/${formattedCategory}`;

    setDynamicAdUnitName(`${baseAdUnitPath}/Interstitial_320x480`);
  }, [pageType, showAd, hasUserAction, isAdPage]);

  useEffect(() => {
    if (!hasUserAction && !isAdPage) return;
    if (typeof window === 'undefined') return;

    const googletag = window.googletag || { cmd: [] };
    googletag.cmd.push(() => {
      if (
        isMobile &&
        dynamicAdUnitName &&
        isSubscriber === false &&
        !window.location.href.includes('aff')
      ) {
        const interstitialSlot = googletag.defineOutOfPageSlot(dynamicAdUnitName, 'interstitial');
        if (interstitialSlot) {
          interstitialSlot.addService(googletag.pubads());
          googletag.enableServices();
          googletag.display(interstitialSlot.getSlotElementId());
        }
      }
    });
  }, [isMobile, pageType, isSubscriber, dynamicAdUnitName, hasUserAction, isAdPage]);

  const checkAdStartAndEndTime = (adType) => {
    const currentDateTime = new Date();
    const [startDay, startMonth, startYear] = adType?.start_date?.split('/') || [];
    const [startHour, startMinute] = adType?.start_time?.split(':') || [];
    const startDateTime = new Date(startYear, startMonth - 1, startDay, startHour, startMinute);

    const [endDay, endMonth, endYear] = adType?.end_date?.split('/') || [];
    const [endHour, endMinute] = adType?.end_time?.split(':') || [];
    const endDateTime = new Date(endYear, endMonth - 1, endDay, endHour, endMinute);

    return currentDateTime >= startDateTime && currentDateTime <= endDateTime;
  };

  const activatePopUpAd =
    typeof window !== 'undefined' &&
    (window.location.pathname.includes('lite') ||
      (activate_popup &&
        !isEmpty(ads_activation_timings?.popupAds) &&
        checkAdStartAndEndTime(ads_activation_timings.popupAds)));

  useEffect(() => {
    if (typeof window === 'undefined') return;

    let ticking = false;

    const fixGutterAds = () => {
      const lhs = document.getElementById('gutter-lhs');
      const rhs = document.getElementById('gutter-rhs');
      if (!lhs || !rhs) return;

      const normalTopPosition = 285; // Top position when scroll is at 0
      const stickyTopPosition = 126; // Top position when header is sticky
      const scrollPosition = window.pageYOffset;

      // Calculate the scroll range for transition
      const transitionStart = 0;
      const transitionEnd = normalTopPosition - stickyTopPosition; // 285 - 126 = 159px

      if (scrollPosition >= transitionEnd) {
        // Fully scrolled - use sticky position
        lhs.classList.add('sticky');
        rhs.classList.add('sticky');
        lhs.style.top = `${stickyTopPosition}px`;
        rhs.style.top = `${stickyTopPosition}px`;
      } else if (scrollPosition > transitionStart) {
        // During transition - calculate interpolated position
        lhs.classList.add('sticky');
        rhs.classList.add('sticky');
        const progress = scrollPosition / transitionEnd;
        const currentTop = normalTopPosition - progress * (normalTopPosition - stickyTopPosition);
        lhs.style.top = `${currentTop}px`;
        rhs.style.top = `${currentTop}px`;
      } else {
        // At top - use normal position
        lhs.classList.remove('sticky');
        rhs.classList.remove('sticky');
        lhs.style.top = '';
        rhs.style.top = '';
      }
    };

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          fixGutterAds();
          ticking = false;
        });
        ticking = true;
      }
    };

    if (document.documentElement.clientWidth < 768) {
      window.addEventListener('scroll', throttle(handleScroll, 50));
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    // Call once on mount
    fixGutterAds();

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  const handleScroll = () => {
    prevScrollpos = window.pageYOffset <= 0 ? 0 : window.pageYOffset;
  };

  const gutterAdsRhs = () => (
    <div className="responsive-ad-container align-right" id="gutter-rhs">
      <DfpAd adtype={'GutterAds1RHS'} adUnit="RHS_120x600" sizes={[[120, 600]]}></DfpAd>
    </div>
  );

  const gutterAdsLhs = () => (
    <div className="responsive-ad-container align-left" id="gutter-lhs">
      <DfpAd adtype={'GutterAds1LHS'} adUnit="LHS_120x600" sizes={[[120, 600]]}></DfpAd>
    </div>
  );

  return (
    <>
      <MobileBottomSticky />
      <div>
        {activate_gutterAds && isSubscriber === false && isDesktop ? gutterAdsLhs() : null}
        {activate_gutterAds && isSubscriber === false && isDesktop ? gutterAdsRhs() : null}
      </div>
      {activate_all_wap_ads && !isDesktop && isSubscriber === false && (
        <div>
          {activate_wap1 && <DfpAd adtype={'Wap1x1_1'} adUnit={1} sizes={[[1, 1]]}></DfpAd>}
          {activate_wap2 && <DfpAd adtype={'Wap1x1_2'} adUnit={2} sizes={[[1, 1]]}></DfpAd>}
          {activate_wap3 && <DfpAd adtype={'Wap1x1_3'} adUnit={3} sizes={[[1, 1]]}></DfpAd>}
          {activate_wap4 && <DfpAd adtype={'Wap1x1_4'} adUnit={4} sizes={[[1, 1]]}></DfpAd>}
          {activate_wap5 && <DfpAd adtype={'Wap1x1_5'} adUnit={5} sizes={[[1, 1]]}></DfpAd>}
        </div>
      )}
      {showAd && isSubscriber === false && activatePopUpAd && (
        <div className="height-zero">
          <DfpAd
            adtype="PopUpAcrossAllSectionsAndPages"
            adUnit="Interstitial_1x1"
            sizes={[[1, 1]]}
          ></DfpAd>
        </div>
      )}
    </>
  );
};

ValidateAccess.propTypes = {
  environment: PropTypes.string,
  pageType: PropTypes.string.isRequired,
  currentPath: PropTypes.string.isRequired,
  isSubscriber: PropTypes.bool,
  promo_key: PropTypes.array.isRequired,
  promo_replace_key: PropTypes.array.isRequired,
};

const DisplayAds = (props) => <ValidateAccess {...props} />;

DisplayAds.propTypes = {
  pageType: PropTypes.string.isRequired,
  currentPath: PropTypes.string.isRequired,
  isSubscriber: PropTypes.bool.isRequired,
  promo_key: PropTypes.array.isRequired,
  promo_replace_key: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => {
  const { features = {}, publisher = {}, integrations } = state.qt.config;
  return {
    currentPath: state.qt.currentPath || '',
    environment: get(publisher, ['ads', 'environment'], 'production'),
    pageType: get(state, ['qt', 'pageType'], 'home-page'),
    isSubscriber: Boolean(get(state, ['userData', 'isSubscriber'], false)),
    promo_key: get(state, ['qt', 'config', 'features', 'promo_key'], []),
    promo_replace_key: get(state, ['qt', 'config', 'features', 'promo_replace_key'], []),
    activate_all_wap_ads: Boolean(
      get(state, ['qt', 'config', 'publisher', 'activate_all_wap'], true),
    ),
    activate_wap1: Boolean(get(state, ['qt', 'config', 'publisher', 'activate_wap1'], true)),
    activate_wap2: Boolean(get(state, ['qt', 'config', 'publisher', 'activate_wap2'], true)),
    activate_wap3: Boolean(get(state, ['qt', 'config', 'publisher', 'activate_wap3'], true)),
    activate_wap4: Boolean(get(state, ['qt', 'config', 'publisher', 'activate_wap4'], true)),
    activate_wap5: Boolean(get(state, ['qt', 'config', 'publisher', 'activate_wap5'], true)),
    activate_popup: Boolean(get(state, ['qt', 'config', 'publisher', 'activate_popup'], true)),
    activate_gutterAds: Boolean(
      get(state, ['qt', 'config', 'publisher', 'activate_gutterAds'], true),
    ),
    ads_activation_timings: get(state, ['qt', 'config', 'publisher', 'ads_activation_timings'], {}),
    config: { features, publisher, integrations },
  };
};

export default connect(mapStateToProps)(DisplayAds);
